module.exports = __webpack_public_path__ + "img/04_Wolke_iPad_L.9a290e7c.jpg";